import React, { useState, useRef, useEffect } from 'react';
import MessageComponent from './message';
import MessageCreatorContainer from '../containers/message_creator_container';
import RepliesStates from '../types/replies_states';
import createSlice from '../utils/create_slice';
import ShowMoreRepliesButton from './show_more_replies_button';

const Conversation = ({ conversation, currentUser, repliesState, handleRepliesState, handleRepliesCount, desc = true }) => {
  const { messages } = conversation;

  const parentMessages = messages.filter(message => message.parentId === null);
  const initChildMessages = messages.filter(message => message.parentId !== null);
  const [repliesRows, setRepliesRows] = useState(parentMessages);
  const [childMessages, setChildMessages] = useState(initChildMessages);
  const [messageCreatorId, setMessageCreatorId] = useState(null);
  const [incrementRepliesShowCount, setIncrementRepliesShowCount] = useState(3);

  useEffect(() => {
    if (repliesState === RepliesStates.HIDDEN) {
      setIncrementRepliesShowCount(3)
    }

  },[repliesState])

  const scrollable = useRef(null);

  const insertMessage = message => {
    if (message.parentId) {
      setChildMessages([...childMessages, message]);
    } else {
      setRepliesRows([...repliesRows, message]);
      handleRepliesState(RepliesStates.SHOW_ALL);
      setIncrementRepliesShowCount(incrementRepliesShowCount + 1)
      handleRepliesCount();
    }
  }

  const togglMessageCreator = (id) => {
    setMessageCreatorId(id);
  }

  const status = false;
  const rows = [];

  repliesRows.slice(...createSlice(RepliesStates, repliesState, incrementRepliesShowCount)).forEach(message => {
    rows.push(<MessageComponent
                  togglMessageCreator={togglMessageCreator}
                  key={ message.id }
                  message={ message }
                  messageCreatorVisible={messageCreatorId === message.id}
                  currentUser={ currentUser }
                  conversationId={ conversation.id }
                  childMessages={ childMessages }
                  insertMessage={ insertMessage } />
    );
  });

  const showNextTen = () => {
    handleRepliesState(RepliesStates.SHOW_INCREMENT_AMOUNT);
    let nextAmount = incrementRepliesShowCount === 3 ? 7 : 10;
    setIncrementRepliesShowCount(incrementRepliesShowCount + nextAmount);
  }

  return (
    <div className="conversation">
      <div className="message-replies">
        <div className="message-list-contents" ref={ scrollable }>
          { status ? status : (desc ? rows.reverse() : rows) }
        </div>
      </div>
      <ShowMoreRepliesButton rowlength={ repliesRows.length } count={ incrementRepliesShowCount } state={ repliesState } incrementCallback={ showNextTen }/>
      <MessageCreatorContainer currentUser={ currentUser }
                               conversationId={ conversation.id }
                               persistMessageCallback={ insertMessage } />
    </div>
  );
}

export default Conversation;
